import { Link } from 'react-router-dom'
import PageHeader from '../components/PageHeader.jsx'

export default function NotFound() {
  return (
    <div className="fade-up">
      <PageHeader
        eyebrow="Error 404"
        title="This page isn't in the platform."
        lead="The route you followed doesn't exist. It may have moved, or the link was mistyped."
      />
      <Link className="btn btn-primary" to="/">
        Back to Home
      </Link>
    </div>
  )
}
